'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var set = require('./set-b596ef38.cjs');



exports.create = set.create;
exports.first = set.first;
exports.from = set.from;
exports.toArray = set.toArray;
//# sourceMappingURL=set.cjs.map
